
import React, { useState, useEffect } from "react";
import { getSalaryRegister } from "../../api/salaryApi";
import { getAllAllowance } from "../../api/allowanceApi";
import { getAllDeduction } from "../../api/deductionApi";

export default function SalaryReportWithNamesMaster({ reportName, month, year }) {

  const [salaryData, setSalaryData] = useState([]);
  const [allowancesMaster, setAllowancesMaster] = useState([]);
  const [deductionsMaster, setDeductionsMaster] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const [company, setCompany] = useState(sessionStorage.getItem("companyName"));
  const [email, setEmail] = useState(sessionStorage.getItem("email"));
  const [address, setAddress] = useState(sessionStorage.getItem("address"));

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const allowance = await getAllAllowance();
        const deduction = await getAllDeduction();
        setAllowancesMaster(allowance);
        setDeductionsMaster(deduction);
      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };
    fetchMasterData();
  }, []);

  const handleShowReport = async () => {
    setErrorMessage("");
    if (!reportName || !month || !year) {
      setErrorMessage("Please select Report Name and enter Month/Year");
      return;
    }

    const filters = {
      month: parseInt(month),
      year: parseInt(year),
      departmentId: null,
      sectionId: null,
    };

    try {
      const data = await getSalaryRegister(filters);
      setSalaryData(data);
    } catch (error) {
      setSalaryData([]);
      setErrorMessage(error.message);
    }
  };

  const handleClear = () => {
    // setReportName("");
    // setMonth("");
    // setYear("");
    setSalaryData([]);
    setErrorMessage("");
  };

const handlePrint = () => {
  if (!month || !year) {
    alert("Please enter Month and Year before printing.");
    return;
  }

  const content = document.getElementById("salaryReportTable").outerHTML;

  // Convert numeric month (1-12) to full name
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthText = monthNames[parseInt(month, 10) - 1] || month;
  const monthYear = `${monthText} ${year}`;

  const printWindow = window.open("", "", "height=800,width=1200");

  printWindow.document.write(`
    <html>
      <head>
        <title>Salary Report - ${monthYear}</title>
          
        <style>
          @page { size: A4 landscape; margin: 10mm; }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            font-size: 12pt;
          }
          /*h3 { text-align: center; margin-bottom: 10px; }
          h2, h4 { text-align: center; margin: 4px 0; } */

h2 {
  text-align: center;
  margin: 6px 0;
  font-size: 20pt;   /* Company name */
  font-weight: bold;
}

h4 {
  text-align: center;
  margin: 2px 0;
  font-size: 14pt;   /* Email + Address */
}

h3 {
  text-align: center;
  margin: 8px 0;
  font-size: 18pt;   /* Employees Salary Register */
  font-weight: bold;
  text-decoration: underline;
}


          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12pt;
            table-layout: auto;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px;
            line-height: 1.6;     /* add vertical spacing */
            vertical-align: middle;
          }
          th {
            background-color: #f0f0f0;
            text-align: center;
          }
          /* Left-align first 3 columns, right-align others */
          /* td:nth-child(-n+3), th:nth-child(-n+3) {
            text-align: left;
          }
          td:nth-child(n+4), th:nth-child(n+4) {
            text-align: right;
          } */

          /* Keep headers always centered */
          th {
            background-color: #f0f0f0;
            text-align: center;
          }

          /* Left-align first 3 columns (data only) */
          td:nth-child(-n+3) {
            text-align: left;
          }

          /* Right-align other columns (data only) */
          td:nth-child(n+4) {
            text-align: right;
            font-size: 16pt; 
          }


          tbody tr:nth-child(odd) { background-color: #f9f9f9; }

          @media print {
            body { -webkit-print-color-adjust: exact; }
            html, body { zoom: 75%; }
            table { page-break-inside: auto; }
            tr { page-break-inside: avoid; page-break-after: auto; }
            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }
          }
        </style>
      </head>
      <body>
        <h2>${company}</h2>
        <h4>Email: ${email}</h4>
        <h4>Address: ${address}</h4>
        <h3>Employees Salary Register - ${monthYear}</h3>
          ${content}
      </body>
    </html>
  `);
    //<h3>${company} ${email} ${address}</h3>

  // Suggest filename in print-to-PDF dialog
  printWindow.document.title = `Salary_Report_${monthYear}`;
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};


  // Map allowances/deductions dynamically
  const mapAllowances = (row) =>
    allowancesMaster.map((a, index) => ({
      name: a.allowanceName,
      value: row[`allowance${index + 1}`] || 0,
    }));

  const mapDeductions = (row) =>
    deductionsMaster.map((d, index) => ({
      name: d.deductionName,
      value: row[`deduction${index + 1}`] || 0,
    }));

    // Calculate totals
  const totals = salaryData.reduce((acc, row) => {
      // Gross Salary
      acc.grossSalary += row.grossSalary || 0;

      // Total Allowance
      acc.totalAllowance += row.totalAllowance || 0;

      // Total Deduction
      acc.totalDeduction += row.totalDeduction || 0;

      // Net Salary
      acc.netSalary += row.netSalary || 0;

      // Dynamic allowances
      allowancesMaster.forEach((_, index) => {
        const key = `allowance${index + 1}`;
        acc[key] = (acc[key] || 0) + (row[key] || 0);
      });

      // Dynamic deductions
      deductionsMaster.forEach((_, index) => {
        const key = `deduction${index + 1}`;
        acc[key] = (acc[key] || 0) + (row[key] || 0);
      });

      return acc;
    }, {
      grossSalary: 0,
      totalAllowance: 0,
      totalDeduction: 0,
      netSalary: 0,
      ...Object.fromEntries(allowancesMaster.map((_, i) => [`allowance${i+1}`, 0])),
      ...Object.fromEntries(deductionsMaster.map((_, i) => [`deduction${i+1}`, 0]))
  });


  return (
    // <div style={{ width: "100%", marginTop: "1rem" }}>
    //  <div className="container mt-4" style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
    <div className="container-fluid mt-4" style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto', overflowX: 'hidden' }}>
 
      <h3>Salary Sheet</h3>

      <div className="row mb-3">
        <div className="col-4 d-flex align-items-end">
          <button onClick={handleShowReport} className="btn btn-primary btn-sm me-2">Show</button>
          {/* <button onClick={handlePrint} className="btn btn-success btn-sm me-2">Print</button> */}
          <button onClick={handleClear} className="btn btn-secondary btn-sm">Clear</button>
          {salaryData.length > 0 && (
            <button onClick={handlePrint} className="btn btn-success btn-sm ms-2">Print</button>
          )}
        </div>
      </div>

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      {salaryData.length > 0 && (
        // <div className="table-responsive" id="salaryReportTable">
        //   <table className="table table-bordered table-striped table-hover" style={{ width: "max-content" }}>
        
        //main-scroll-x
          <div className="table-responsive" id="salaryReportTable"> 
           <table className="table table-bordered table-striped table-hover" style={{minWidth: 1200 }}> 
        
            <thead className="table-dark" style={{ fontSize: "10pt", lineHeight: "1.6" }}>
              <tr>
                <th style={{ textAlign: "center" }}>Sr.No.</th>
                <th className="text-center">Employee Name</th>
                <th className="text-center">Employee Code</th>
                <th className="text-center">Gross Salary</th>
                {allowancesMaster.map((a) => <th key={a.allowanceID} className="text-center">{a.allowanceName}</th>)}
                <th className="text-center">Total Allowance</th>
                {deductionsMaster.map((d) => <th key={d.deductionID} className="text-center">{d.deductionName}</th>)}
                <th className="text-center">Total Deduction</th>
                <th className="text-center">Net Salary</th>
              </tr>
            </thead>
            <tbody>
              {salaryData.map((row, idx) => {
                const mappedAllowances = mapAllowances(row);
                const mappedDeductions = mapDeductions(row);
                return (
                  <tr key={idx}>
                    <td style={{ textAlign: "center" }}>{row.srNo}</td>
                    <td className="text-start">{row.employeeName}</td>
                    <td className="text-start">{row.employeeCode}</td>
                    <td className="text-end">{row.grossSalary}</td>
                    {mappedAllowances.map((a, i) => <td key={i} className="text-end">{a.value}</td>)}
                    <td className="text-end">{row.totalAllowance}</td>
                    {mappedDeductions.map((d, i) => <td key={i} className="text-end">{d.value}</td>)}
                    <td className="text-end">{row.totalDeduction}</td>
                    <td className="text-end">{row.netSalary}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className="bg-light font-weight-bold" style={{ fontSize: "14pt" }}>
                <td colSpan={3} className="text-end">Total</td>
                <td className="text-end">{totals.grossSalary}</td>

                {allowancesMaster.map((_, i) => (
                  <td key={`allowance-${i}`} className="text-end">{Math.round(totals[`allowance${i+1}`])}</td>
                ))}
                <td className="text-end">{Math.round(totals.totalAllowance)}</td>
            
                {deductionsMaster.map((_, i) => (
                  <td key={`deduction-${i}`} className="text-end">{Math.round(totals[`deduction${i+1}`])}</td>
                ))}
                <td className="text-end">{Math.round(totals.totalDeduction)}</td>
                
                <td className="text-end">{Math.round(totals.netSalary)}</td>
              </tr>
            </tfoot>

          </table>
        </div>
      )}
    </div>
  );

      
}
